export default {
  businessLogisticsCompany: {
    common: {
      add: '新增',
      status: '状态',
      addBusiness: '新增业务',
      editBusiness: '编辑业务',
      addAssociated: '新增关联',
      editAssociated: '编辑关联',
    },
    table: {
      logisticsCompanyName: '物流业务名称',
      logisticsCompanyName2: '物流公司',
      status: '状态',
      creator: '创建人',
      createTime: '创建时间',
      action: '操作',
      logisticsCompanyNameInput: '请输入物流商名称',
      chooseText: '请选择',
    },
    delDialog: {
      confirmMsg: '您正在删除该数据，是否继续？',
      warning: '提示'
    }
  }
};

